import { canonicalInstitutionPathname } from "./institutional-routing";
import { classStateKeys, studentClassesHref } from "./classroom-navigation.mjs";

const LEGACY_PLATFORM_PATHS: Readonly<Record<string, string>> = {
  "/platform/admin": "/app/admin-platform/users",
  "/platform/advisor": "/app/admin-platform/advisor",
  "/platform/errors": "/app/admin-platform/errors",
};

export function migrateLegacyPlatformPathname(pathname: string) {
  const localeMatch = pathname.match(/^\/(pt-BR|en-GB|es-ES)(\/.*)$/i);
  const localePrefix = localeMatch ? `/${localeMatch[1]}` : "";
  const path = localeMatch ? localeMatch[2] : pathname;
  const migrated = LEGACY_PLATFORM_PATHS[path];
  return migrated ? `${localePrefix}${migrated}` : null;
}

export function notificationHref(actionUrl?: string, currentSearch?: Pick<URLSearchParams, "toString">) {
  if (!actionUrl?.startsWith("/") || actionUrl.startsWith("//")) return "/app";
  const target = new URL(actionUrl, "https://aulyn.local");
  if (target.pathname === "/app/classes" && target.searchParams.has("classInvitation") && currentSearch) {
    return studentClassesHref(currentSearch, {...Object.fromEntries(classStateKeys.map(key => [key, null])), classInvitation: target.searchParams.get("classInvitation")}, true);
  }
  const migratedPlatformPath = migrateLegacyPlatformPathname(target.pathname);
  if (migratedPlatformPath) return `${migratedPlatformPath}${target.search}`;
  if (target.pathname === "/my-space") {
    const mapId = target.searchParams.get("map");
    const nodeId = target.searchParams.get("node");
    if (mapId) return `/app/maps/${encodeURIComponent(mapId)}${nodeId ? `?node=${encodeURIComponent(nodeId)}` : ""}`;
    return "/app/library";
  }
  return `${canonicalInstitutionPathname(target.pathname)}${target.search}${target.hash}`;
}
